import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const automaticdebitsRoutes = {
  path: '/automaticdebits',
  name: 'automaticdebits',
  component: Layout,
  redirect: '/automaticdebits/dash',
  alwaysShow: true,
  meta: {
    title: 'Prélèvements auto.',
    icon: 'mdi:currency-eur',
    permissions: [P.PRLV.BROWSE],
  },
  children: [
    // Voir les prlv. en attente et la liste des remises
    {
      path: '/automaticdebits/dash',
      name: 'Prélèvements automatiques',
      meta: { title: 'Prélèvements', icon: 'mdi:list-box-outline', noCache: true, permissions: [P.PRLV.BROWSE] },
      component: () => import('@/views/automaticdebits/Dash.vue'),
      hidden: false,
    },

    // édition des premières pages des factures + export csv des factures pour la compta
    {
      path: '/automaticdebits/docs',
      name: 'Documents',
      meta: { title: 'Documents clients', icon: 'mdi:file-document-multiple-outline', noCache: true, permissions: [P.REMISES.BROWSE] },
      component: () => import('@/views/automaticdebits/Docs.vue'),
      hidden: false,
    },

    // voir 1 une remise de prlv en fonction d'un id
    {
      path: '/automaticdebits/show/:id_remise(\\d+)',
      component: () => import('@/views/automaticdebits/Show.vue'),
      name: 'Voir Remise',
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: { title: 'Remise', permissions: [P.REMISES.BROWSE] },
      hidden: true,
    },

    // Chorus - Voir et editer les premières pages des factures des clients sous chorus
    {
      path: '/automaticdebits/dashChorus',
      name: 'chorus',
      meta: { title: 'Documents Chorus', icon: 'mdi:wallet-bifold-outline', noCache: true, permissions: [P.INVOICES.BROWSE] },
      component: () => import('@/views/automaticdebits/dashChorus.vue'),
      hidden: false,
    },
  ]
}

export default automaticdebitsRoutes
